export default __webpack_public_path__ + "static/media/PJL02.ed01a82b.png";